import * as store from './store';
import * as env from './env';

export function loadPermissionBaseUrl() {
	// Priority 1: explicit buildConfig endpoint (platform-provided)
	if (window && window.buildConfig && window.buildConfig.endpoint && window.buildConfig.endpoint.permissions) {
		return window.buildConfig.endpoint.permissions;
	}

	// Priority 2: Construct URL from passport app short name and environment (Morpheus Lite flow)
	try {
		const passport = store.get('passport');
		const appShortName = passport && passport.appShortName ? passport.appShortName : null;
		if (appShortName && window && window.location) {
			const hostname = window.location.hostname || '';
			const envName = env.environmentFromPassportDomain(hostname);
			const passportDomain = env[envName] && env[envName].passportDomain ? env[envName].passportDomain : null;
			if (passportDomain) {
				const protocol = window.location.protocol || 'https:';
				return `${protocol}//${appShortName}.${passportDomain}/service/permissionapi/api`;
			}
		}
	} catch (e) {
		// ignore and fall back to legacy URL
	}

	// Legacy fallback
	return '/service/permissionapi/api';
}

export function getAppBaseUrl(){
	const isMorpheus = window.buildConfig && window.buildConfig.isMorpheus;
	const segments = window.location.pathname.split('/').filter(segment => segment);

	// If isMorpheus is not set, check if current URL matches K12 domains as fallback
	let shouldUseAppBaseUrl = isMorpheus;
	if (isMorpheus == null) {
		const currentUrl = window.location.href;
		const k12Pattern = /(k12\.ss\.frontlineeducation\.com|k12\.frontlineeducation\.com)/i;
		shouldUseAppBaseUrl = k12Pattern.test(currentUrl);
	}

	// if we are in morpheus, we need to get the app base url and check if it has an app or service in the path
	// then we need to get the first two segments otherwise blank
	// Added similar logic in the router.js, auth.js in angular framework and in Supersuit-Jarvis
	const appBaseUrl = segments.length >= 3 && shouldUseAppBaseUrl && (segments[0] === 'app' || segments[0] === 'service') ? segments.slice(0, 2).join('/') : '';
	return appBaseUrl;
}

export function getBaseUrlForModule(url, param) {
	const currentUrl = window.location.href;
	const k12Pattern = /(k12\.ss\.frontlineeducation\.com|k12\.frontlineeducation\.com)/i;

	// Check if current URL matches K12 domains
	if (k12Pattern.test(currentUrl)) {
		if (param) {
			// Extract the subdomain and domain parts
			const urlObj = new URL(currentUrl);
			const hostParts = urlObj.hostname.split('.');

			// Find the index where k12 starts
			const k12Index = hostParts.findIndex(part => part.toLowerCase() === 'k12' || part.toLowerCase().includes('stage-k12'));

			// Get the subdomain prefix (everything before k12/stage-k12)
			const subdomainPrefix = k12Index > 0 ? hostParts.slice(0, k12Index).join('.') : '';

			// Get the domain suffix (everything from k12 onwards)
			const domainSuffix = hostParts.slice(k12Index).join('.');

			// Construct new URL with subdomain-param.domain pattern
			const newHostname = subdomainPrefix ? `${subdomainPrefix}${param}.${domainSuffix}` : `${param}.${domainSuffix}`;

			return `${urlObj.protocol}//${newHostname}`;
		}
		return '';
	}

	// Return the passed URL parameter if not K12
	return url;
}
